export function getFetchPolicy(forceRefetch) {
    return forceRefetch ? "network-only" : "cache-first";
}
